import { request } from './_core'

export interface AdvancedStats {
  avgScore:               number | null
  bestActivity:           { slug: string; avgScore: number } | null
  totalSessions:          number
  categoryPerformance:    Record<string, number>
  currentWeekPerformance: Record<string, number>
  lastWeekPerformance:    Record<string, number>
  categoryEvolution:      Record<string, { date: string; avgScore: number }[]>
  activityEvolution:      Record<string, { date: string; score: number | null; totalDurationSeconds: number | null }[]>
}

export type DateRangePreset =
  | 'today'
  | 'this-week'
  | 'this-month'
  | 'last-3-months'
  | 'last-6-months'
  | 'this-year'
  | 'all-time'

export interface AdvancedStatsParams {
  dateRange?:  DateRangePreset
  activities?: string[]
  categories?: string[]
}

export const statsApi = {
  advanced: (params?: AdvancedStatsParams) => {
    const qs = new URLSearchParams()
    if (params?.dateRange) qs.set('dateRange', params.dateRange)
    if (params?.activities && params.activities.length > 0) qs.set('activities', params.activities.join(','))
    if (params?.categories && params.categories.length > 0) qs.set('categories', params.categories.join(','))
    const path = qs.toString() ? `/users/me/advanced-stats?${qs.toString()}` : '/users/me/advanced-stats'
    return request<AdvancedStats>(path)
  },
}
